import { useState } from 'react';
import { useUtilsEffect } from '@zardoy/react-util';
import { appViewer } from '../appViewer';
const readFromMainThreadWorld = (world) => {
    const loadedSectionsChunks = {};
    for (const sectionPos of Object.keys(world.sectionObjects)) {
        const [x, , z] = sectionPos.split(',').map(Number);
        loadedSectionsChunks[`${x},${z}`] = true;
    }
    return {
        loadedSectionsChunks,
        loadedChunks: world.loadedChunks,
        finishedChunks: world.finishedChunks,
    };
};
const emptyRendererChunksState = () => ({
    loadedSectionsChunks: {},
    loadedChunks: {},
    finishedChunks: {},
});
export const useRendererChunksDebugState = (update) => {
    const [state, setState] = useState(() => {
        const world = globalThis.world;
        return world ? readFromMainThreadWorld(world) : emptyRendererChunksState();
    });
    useUtilsEffect(({ interval }) => {
        interval(500, () => {
            const world = globalThis.world;
            if (world) {
                setState(readFromMainThreadWorld(world));
                return;
            }
            const getChunksDebugState = (appViewer.backend?.backendMethods)?.getChunksDebugState;
            if (!getChunksDebugState) {
                setState(emptyRendererChunksState());
                return;
            }
            void Promise.resolve(getChunksDebugState()).then(setState).catch(() => {
                setState(emptyRendererChunksState());
            });
        });
    }, [update]);
    return state;
};
